<template>
  <div class="login_con" style="min-height: 0;">
      <ul class="tabs">
        <li class="tab1_1 lr10" @click="switchTo('1')" style="cursor: pointer;">
          <a name=".tab1_3" :class="{current:currentTab.index=='1'}">密码登录</a>
        </li>
        <li class="tab1_1 lrr10" @click="switchTo('2')" style="cursor: pointer;">
          <a name=".tab1_4" :class="{current:currentTab.index=='2'}">验证码登录</a>
        </li>
      </ul>
      <div class="tab_content">
        <!--密码登录-->
        <form class="tab1_3 l_left" v-show="currentTab.index == '1'" data-vv-scope="form1" novalidate>
          <p>
            <input v-validate="'required'" v-model="form1.accountName" name="accountName" type="text" placeholder="账号" class="put_tel input_one" id="userphone" />
          </p>
          <i class="spa spa2">{{ errors.first('form1.accountName') }}</i>
          <p class="mt20">
            <input v-validate="'required'" v-model="form1.password" name="password" type="password" placeholder="密码" class="put_ps input_one" id="useraddress"/>
          </p>
          <i class="spa spa3">{{ errors.first('form1.password') }}</i>
          <p class="mt20" v-if="authRequired">
            <input name="verify" type="text" class="w235 put_txt input_two paddingR_0" placeholder="验证码" v-validate="'required'" v-model="form1.verify" />
            <label @click="refreshPicCode">
              <pic-auth-code :identify-code="code"></pic-auth-code>
            </label>
          </p>
          <i class="spa5" v-if="authRequired">{{ errors.first('form1.verify') }}</i>
          <ul>
            <li class="col_1"><input name="" style="opacity: 1;" type="checkbox" v-model="form1.checked" @click="rme(form1.checked)" /> 记住帐号</li>
            <li class="col_2">
              <a @click="toFindPwd" class="red_font" style="cursor: pointer;">忘记密码?</a>
              <!--router-link to="/byl/reg" class="red_font">去注册 ></router-link-->
            </li>
          </ul>
          <p class="wrap w264 mt50">
            <input v-if="!formSubmitting1" v-debounce-click type="button" @click="validateForm('form1')" class="login_btn login_b input_one" value="登录" id="sub" />
            <input v-if="formSubmitting1" type="button" class="login_btn login_b input_one" value="登录中..." disabled>
          </p>
        </form>
        <!--/密码登录-->
        <!--验证码登录-->
        <form class="tab1_4 l_left" v-show="currentTab.index == '2'" data-vv-scope="form2" novalidate>
          <p><input v-validate="'required|phone'" v-model="form2.phone" name="phone" type="text" placeholder="手机号" class="put_tel input_two" id="yzmPhone"/></p>
          <i class="spa spa2">{{ errors.first('form2.phone') }}</i>
          <p class="mt20">
            <input name="code" type="text" class="w235 put_txt input_two paddingR_0" placeholder="验证码" id="yzmNum" v-validate="'required'" v-model="form2.code" />
            <get-auth-code @retrieving="getCode" @input-error="popup" :phone="form2.phone"></get-auth-code>
          </p>
          <i class="spa5">{{ errors.first('form2.code') }}</i>
          <p class="wrap w264 mt50">
            <input v-if="!formSubmitting2" v-debounce-click type="button" @click="validateForm('form2')" class="login_btn login_b input_two" value="登录" id="sub2"/>
            <input v-if="formSubmitting2" type="button" class="login_btn login_b input_one" value="登录中..." disabled>
          </p>
        </form>
        <!--/验证码登录-->
      </div>
    </div>
</template>
<script>
  import getAuthCode from '@/components/common/common/getAuthCode.vue'
  import picAuthCode from '@/components/common/common/picAuthCode.vue'
  import utils from '@/utils'
  import { getCookie, removeCookie } from '@/store/cookies.js'
  import { mapState, mapActions } from 'vuex'
  import '@/utils/validator.js'
  export default {
    components: { getAuthCode, picAuthCode },
    mounted () {
      var userSession = getCookie('rme_fresh') // 取记住我cookie值
      if (userSession) {
        this.form1.accountName = userSession.phone
        this.form1.password = userSession.password
        this.form1.checked = true
      }
      if (this.login_auth_required) {
        this.clearLoginAuth()
      }
    },
    watch: {
      authRequired: {
        handler (val) {
          if (val) {
            this.code = val
          }
        },
        deep: true
      }
    },
    data () {
      return {
        form1: {}, // 普通登录
        form2: {}, // 验证码登录 (注册)
        code: '',
        currentTab: {
          index: '1',
          isActive: true
        }
      }
    },
    computed: {
      ...mapState('auth', ['login_auth_required']),
      tabClass () {
        return {
          current: this.currentTab.isActive === true
        }
      }
    },
    methods: {
      ...mapActions('auth', ['getPicCode', 'clearLoginAuth']),
      toFindPwd () {
        this.$router.push({path: '/findpwd'})
      },
      popup (msg) {
        this.$toasted.show(msg)
      },
      switchTo (index) {
        this.currentTab.index = index
        this.currentTab.isActive = !this.currentTab.isActive
      },
      getCode () { // 验证码登录获取手机验证码
        this.$emit('ready-to-get-code', this.form2.phone)
      },
      refreshPicCode () {
        this.getPicCode()
      },
      rme (checked) {
        if (checked) { // 删除cookie
          removeCookie('rme_fresh')
        }
      },
      validateForm (scope) {
        var bus = this
        this.$validator.validateAll(scope).then(function (result) {
          if (result) {
            bus.login()
          } else {
            bus.popup('请确保信息正确与完整')
            return false
          }
        })
      },
      login () {
        let form = (this.currentTab.index === '1') ? this.form1 : this.form2
        this.$emit('ready-for-login', [this.currentTab.index, form])
      }
    },
    props: ['user', 'authRequired', 'formSubmitting1', 'formSubmitting2']
  }
</script>
<style scoped>
  @import '../assets/login.css';
</style>



// WEBPACK FOOTER //
// src/pages/auth/login/login.vue